import api from 'api/api';
import axios from 'axios';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {gameRewardRequest} from 'api/apiHelper';

export const fetchGameRewardRequest = createAsyncThunk(
  'gameRewardRequest/fetchGameRewardRequest',
  async (arg, {signal}) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    const response = await api(gameRewardRequest({cancelToken: source.token}));
    return response.data;
  }
);

const extraReducers = {
  [fetchGameRewardRequest.pending]: (state, action) => {
    state.request = {...action.payload, loading: true};
  },
  [fetchGameRewardRequest.fulfilled]: (state, action) => {
    state.request = {...action.payload, loading: false};
  },
};

const name = 'gameRewardRequest';

const initialState = {
  request: [],
};

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers,
});

export const {reset} = slice.actions;

export default slice.reducer;
